export namespace DashBoard {
    /** 仪表盘组件类型 */
    export enum ComponentType {
        /** 地图 */
        MAP = 'map',
        /** 柱状图 */
        BAR = 'bar',
        /** 堆叠柱状图 */
        PILEBAR = 'pileBar',
        /** 条形图 */
        STRIPE = 'stripe',
        /** 堆叠条形图 */
        PILESTRIPE = 'pileStripe',
        /** 折线图 */
        LINE = 'line',
        /** 面积图 */
        AREA = 'area',
        /** 饼图 */
        PIE = 'pie',
        /** 漏斗图 */
        FUNNEL = 'funnel',
        /** 雷达图 */
        RADAR = 'radar',
        /** 透视图 */
        TABLE = 'table',
        /** 交叉表 */
        CROSSTABLE = 'crosstable',
        /** 明细表 */
        LIST = 'list',
        /** 指标图 */
        CARD = 'card',
        /** 散点图（气泡图） */
        SCATTER = 'scatter',
        /** 双轴图 */
        BIAX = 'biax',
        /** 文本图 */
        LONGTEXT = 'longText',
        /** 图片 */
        IMAGE = 'image',
        /** 过滤器 */
        FILTERPICKER = 'filterPicker',
        /** 进度图 */
        PROGRESSBAR = 'progressBar',
        /** 仪表图 */
        GAUGE = 'gauge',
        /** web组件 */
        WEB = 'web',
        /** button组件 */
        BUTTON = 'button',
        /** tab组件 */
        TAB = 'tab',
        /** 日历组件 */
        CALENDAR = 'calendar',
        /** 对比漏斗图 */
        FUNNELCOMPARE = 'funnelCompare',
        /** 百分比堆积柱状图 */
        PERCENTPILEBAR = 'percentPileBar',
        /** 百分比堆积条形图 */
        PERCENTPILESTRIPE = 'percentPileStripe',
        /** 时间组件 */
        CLOCK = 'clock',
    }

    /** 仪表盘组件类型 */
    export interface IReportWidget {
        /** 编码 */
        code: string;

        /** 名称 */
        displayName: string;

        /** 报表编码 */
        parentCode: string;

        /** 应用编码 */
        appCode: string;

        /** 图表类型 */
        // nodeType: WidgetType;

        /** 组件类型 */
        type: ComponentType;
    }

    /** 仪表盘单图表暂不支持的组件类型 */
    export const UN_SUPPORT_COMPONENT_TYPE_IN_SINGLE_CHART = [
        ComponentType.BUTTON,
        ComponentType.CLOCK,
        ComponentType.LONGTEXT,
        ComponentType.WEB,
        ComponentType.IMAGE,
        ComponentType.FILTERPICKER,
        ComponentType.CALENDAR,
        ComponentType.TAB,
    ];

    /** 升级记录项 */
    export type UpgradeRecordItem = {
        /** 旧报表编码 */
        ReportNode: string;
        /** 仪表盘编码 */
        DashBoardNode: string;
        /** 报表名称 */
        DisplayName: string;
        /** 转换状态 */
        Successful: boolean;
        /** 迁移结果与错误信息 */
        ErrorMessage: string;
    };
}
